import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: "https://keycloak.pocketpilot.jura.com/",
  realm: "Jura",
  clientId: "business-card-operator-frontend",
});
// keycloak.init({ onLoad: 'check-sso' });

export default keycloak;
